<template>
  <section id="use" class="use">
    <div class="head">
      <div class="head__subtitle">
        {{ $t('availableAttractive') }}
      </div>
      <div class="head__title">{{ $t('createYourDream') }}</div>
    </div>
    <div class="use__video">
      <ModulesOfferCardVideo
        v-for="(item, index) in rowOfferData"
        :autoplay="true"
        :src-video="item.src"
        :video-poster="item.poster"
        :key="item.src"
        :title-number="index + 1"
        :title="item.title"
        :sub-title="item.description"
      />
    </div>
    <ui-button
      :size="ButtonSizeType.large"
      :label="$t('tryForFree')"
      color="primary-offer"
      ref="btnRef"
      class="use__btn dwnload-btn btn btn_lg"
      @click="actionHandler"
    >
      <template v-if="!isMobile" #before><IconWindows /></template>
    </ui-button>
  </section>
</template>

<script setup lang="ts">
import {ButtonSizeType} from '~/interfaces/ui/button';
import {useUserStore} from '~/modules/User/user.store';
import {useBaseStore} from '~/modules/BaseModule/base.store';
import IconWindows from '~/assets/svg/windows-icon.svg';
import {useI18n} from 'vue-i18n';
import {useRuntimeConfig} from '#imports';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const router = useRouter();
const {locale} = useI18n();
const base = useBaseStore();

const isMobile = computed(() => base.isMobile);
const rowOfferData = ref([
  {
    title: 'createRooms',
    description: 'createrRoomsDesc',
    src: [`${staticUrl}/video/01-layout.mp4`],
    preload: 'auto',
    type: ['video/mp4'],
    poster: `${staticUrl}/images/offer-video-01-layout.webp`,
  },
  {
    title: 'addStyle',
    description: 'addStyleDesc',
    src: [`${staticUrl}/video/interface.mp4`],
    preload: 'none',
    type: ['video/mp4'],
    poster: `${staticUrl}/images/offer-video-interface.webp`,
  },
  {
    title: 'visualizeShare',
    description: 'visualizeShareDesc',
    src: [`${staticUrl}/video/03-scene.mp4`],
    preload: 'none',
    type: ['video/mp4'],
    poster: `${staticUrl}/images/offer-video-03-scene.webp`,
  },
]);

import {goTo} from '~/helpers/baseFunction';

const actionHandler = () => {
  goTo('#tariff');
}
</script>

<style scoped lang="scss">
.use {
  margin-top: -$mt-21;
  width: 100%;
  min-height: calc(100vh - $mt-30);
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  margin-top: $mt-20;
  padding-top: $mt-10;
  margin-bottom: $m-20;

  &__btn {
    margin-top: $mt-12;
    width: 100%;
    max-width: 335px;

    @media (max-width: $md) {
      margin-top: 0px;
    }
  }

  &__video {
    margin-top: 8vh;
    display: flex;
    flex-wrap: wrap;
    gap: 3%;

    .card {
      width: 31.3%;
      height: 100%;
      min-height: 400px;

      &__video {
        height: 200px;
      }
    }

    @media (max-width: $lg) {
      flex-direction: column;
      max-width: 100%;

      .card {
        width: 100%;
      }
    }

    @media (max-width: $md) {
      gap: $g-3;
      .card {
        gap: $g-5;
      }
    }
  }

  .head {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .head__subtitle {
      margin-bottom: 16px;
      max-width: 30vw;
      @include subtitle-fs-14-fw-400-gray-200;
      text-align: center;

      @media (max-width: $lg) {
        max-width: 90vw;
      }
    }
    .head__title {
      @include headline-h1;
      text-align: center;
      max-width: 55vw;
      @media (max-width: $lg) {
        max-width: 90vw;
      }
    }
  }
  .main {
    width: 100%;
    // height: 673px;
    display: flex;
    flex-direction: column;
    gap: 96px;
    .offer-row {
      display: flex;
      gap: 24px;
      align-items: center;
      &:nth-child(2n) {
        flex-direction: row-reverse;
      }
      .offer-row-info {
        display: flex;
        flex-direction: column;
        width: calc(100% * 0.43);
        gap: 40px;
        &-title {
          background: $primary;
          padding: 4px 16px;
          // width: calc(100% * 0.8);
          width: fit-content;
          color: var(--white-theme-white-000, #fff);
          font-family: Segoe UI;
          font-size: 24px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          letter-spacing: 0.72px;
          text-transform: uppercase;
        }
        &-desc {
          color: var(--white-theme-black-200, #64686e);
          font-family: Segoe UI;
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          letter-spacing: 0.36px;
        }
      }
      video {
        display: block;
        width: calc(100% * 0.57);
        box-shadow: 0px 0px 8px 0px rgba(24, 25, 26, 0.08),
          0px 0px 16px 0px rgba(24, 25, 26, 0.12),
          0px 0px 32px 0px rgba(24, 25, 26, 0.16);
      }
    }
  }
  @media (min-width: 2000px) {
    min-height: unset;
  }
  @media (max-width: $lg) {
    margin-top: $mt-2;
    width: 100%;
    min-height: 100vh;
  }
  @media (max-width: $md) {
    gap: $g-5;
    margin-bottom: $m-10;
  }
}
</style>
